module.exports = __webpack_public_path__ + "static/img/icon_img3.4febcad4.png";